import { render, staticRenderFns } from "./Positions.vue?vue&type=template&id=c8991856"
import script from "./Positions.vue?vue&type=script&lang=ts"
export * from "./Positions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports